module.exports = __webpack_public_path__ + "img/หอยนางรม.b42c13c6.jpg";